"use client";

import { SideNav } from "@/components/SideNav";
import { SkillsPage } from "@/components/SkillsPage";

export default function SkillsPageClient() {
  return (
    <>
      <SideNav />
      <SkillsPage />
    </>
  );
}
